import { removeCookie, setCookie } from '../cookie/cookieUtils';

const BETA_COOKIE_NAME = 'isBeta';
const BETA_COOKIE_VALUE = 'true';

function getBetaCookieOptions(): {
  path: string;
  secure: boolean;
  sameSite: 'lax';
  domain?: string;
} {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname.endsWith('.localhost')) {
    return {
      path: '/',
      secure: false,
      sameSite: 'lax',
      domain: 'localhost',
    };
  }

  const parts = hostname.split('.');
  const domain = `.${parts.slice(1).join('.')}`;

  return {
    path: '/',
    secure: true,
    sameSite: 'lax',
    domain,
  };
}

function setBetaCookie(): void {
  if (typeof window === 'undefined') return;

  setCookie(BETA_COOKIE_NAME, BETA_COOKIE_VALUE, getBetaCookieOptions());
}

function removeBetaCookie(): void {
  if (typeof window === 'undefined') return;

  removeCookie(BETA_COOKIE_NAME, getBetaCookieOptions());
}

export { BETA_COOKIE_NAME, BETA_COOKIE_VALUE, getBetaCookieOptions, removeBetaCookie, setBetaCookie };
